import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { fetchMasterTurnsRemaining } from "../../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { PopUpForm } from "../../../../../common/popup/popUpForm/popUpForm";
import { validateDefaultForm } from "../../../utils/utils";
import { MasterTurnsForm } from "./form/form";
import { PopUpCodes } from "../../../../../../common/enum/PopUpCodes";
import { postToMasterTurnForm } from "../../../../../../redux/actions/resources/master/turns/turns";
import { setShowPopUpMaster } from "../../../../../../redux/reducers/resources/master/master";
import { resetMasterTurnsForm } from "../../../../../../redux/reducers/resources/master/turns/form";
import { RequiredFieldsMessage } from "../../../../../common/requiredMessage/requiredMessage";

interface IMasterTurnsFormController {
    widthPopUp: any;
    heigthPopUp: any;
}

export const MasterTurnsFormController: React.FC<IMasterTurnsFormController> = ({ widthPopUp, heigthPopUp }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });
    const { showPopUp } = useAppSelector((state) => state.masterPopUp);
    const { form, loading } = useAppSelector((state) => state.masterTurnsForm);
    const { data } = useAppSelector((state) => state.catalog.turnRemaining);

    const onAcceptPopUp = () => {
        dispatch(postToMasterTurnForm()).then((response: any) => {
            if (response) {
                onCancelPopUp();
                data.length && dispatch(fetchMasterTurnsRemaining());
            }
        });
    };

    const onCancelPopUp = () => {
        dispatch(setShowPopUpMaster(PopUpCodes.NONE));
    };
    const onDimissed = () => {
        dispatch(resetMasterTurnsForm());
    };
    const showNotData = useMemo(() => {
        return !data.length ? true : false;
    }, [data]);

    const titlePopUp = useMemo(() => {
        if (showPopUp === PopUpCodes.CREATE) {
            return `${t("CREATE")}  ${t("BUTTON.TURNS")}`;
        } else if (showPopUp === PopUpCodes.UPDATE) {
            return `${t("UPDATE")}  ${t("BUTTON.TURNS")}`;
        }
        return "";
    }, [showPopUp]);

    const isDisabledButton = useMemo(() => {
        return validateDefaultForm(form, showPopUp === PopUpCodes.CREATE);
    }, [form]);

    useEffect(() => {
        showPopUp === PopUpCodes.CREATE && dispatch(fetchMasterTurnsRemaining());
    }, [showPopUp]);

    return (
        <PopUpForm
            content={
                <MasterTurnsForm
                    showNotData={showNotData}
                    data={data}
                />
            }
            title={titlePopUp}
            isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE ? true : false}
            onDimissed={onDimissed}
            onCancel={onCancelPopUp}
            onSave={onAcceptPopUp}
            height={heigthPopUp}
            width={widthPopUp}
            isLoading={loading}
            isDisabledButton={isDisabledButton}
            onlyHidden={showPopUp === PopUpCodes.CREATE ? showNotData : false}
            leftButtonContent={<RequiredFieldsMessage />}
        />
    );
};
